import { render, staticRenderFns } from "./Business-Glossary-Drawer.vue?vue&type=template&id=49c0a36d&lang=pug"
import script from "./Business-Glossary-Drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Business-Glossary-Drawer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports